import urlResolver from 'edrolo/utils/URLResolver';
import { browserHistory } from 'edrolo/utils/browserHistory';

export const generateExamBreadcrumbs = (exam, classId) => {
  const mySubjectsUrl = urlResolver.getPath('courses-page');
  const courseTitle = exam && exam.getIn(['branch_titles', 0]);
  const coursePageUrl = urlResolver.reverse('course-page', {
    classId,
  });
  return [
    { label: 'My subjects', url: mySubjectsUrl, anchor: true },
    { label: courseTitle, url: coursePageUrl },
  ];
};

export const getOptionLabelFromIndex = (index) =>
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')[index] || '';

export const filterQuestions = (questions, searchParams) => {
  if (!questions) {
    return null;
  }

  const workingPaths = searchParams
    .get('working_paths')
    ?.split(',')
    .map(Number);

  const spiciness = searchParams.get('spiciness')?.split(',').map(Number);

  const filterBySpiciness = (questions) => {
    return questions.filter((q) => {
      if (!q.get('spiciness_level')) {
        return true;
      }

      if (spiciness.includes(q.get('spiciness_level'))) {
        return true;
      }
    });
  };

  const filterByPath = (questions) => {
    return questions.filter((q) => {
      if (q.get('working_pathways').size === 0) {
        return true;
      }

      if (
        workingPaths.some((path) => q.get('working_pathways').includes(path))
      ) {
        return true;
      }
    });
  };

  const filterByBoth = (questions) => {
    return filterByPath(filterBySpiciness(questions));
  };

  if (!spiciness && !workingPaths) {
    return questions;
  }

  if (spiciness && workingPaths) {
    return filterByBoth(questions);
  }

  if (spiciness) {
    return filterBySpiciness(questions);
  }

  if (workingPaths) {
    return filterByPath(questions);
  }
};

export const getRootQuestionDescendants = (flatQuestions, questionId) => {
  const question = flatQuestions?.get(`${questionId}`);

  if (!flatQuestions || !question) {
    return null;
  }

  return flatQuestions
    .filter((item) => item.get('tree_id') === question.get('tree_id'))
    .valueSeq();
};

export const getPrevNextQuestionIds = (flatQuestions, questionId) => {
  const flatQuestionIds = flatQuestions
    ?.map((item) => item.get('id'))
    .keySeq()
    .toArray();

  if (!flatQuestionIds) {
    console.warn('There are no flatQuestionIds');
    return { prevId: null, nextId: null };
  }

  const index = flatQuestionIds.indexOf(questionId);

  const prevNextIds = {
    prevId: parseInt(flatQuestionIds[index - 1]) || null,
    nextId: parseInt(flatQuestionIds[index + 1]) || null,
  };

  return prevNextIds;
};

export const setSearchParams = (prevSearchParams, searchParam, value) => {
  const newSearchParams = new URLSearchParams(prevSearchParams);

  const noParam = parseInt(value) === 0 || value.includes(0) || !value.length;

  if (noParam) {
    newSearchParams.delete(searchParam);
  } else {
    newSearchParams.set(searchParam, value);
  }

  browserHistory.replace(
    `${window.location.pathname}?${newSearchParams.toString()}`
  );
};

export const getPrevNextInsights = (emInsightQuestions, questionId) => {
  if (emInsightQuestions.length === 0) {
    console.warn('There are no emInsightQuestions');
    return { prevId: null, nextId: null };
  }

  const index = emInsightQuestions.findIndex(
    (emQuestion) => emQuestion.question_id === questionId
  );

  const prevNextInsights = {
    prevInsight: emInsightQuestions[index - 1] || null,
    nextInsight: emInsightQuestions[index + 1] || null,
  };

  return prevNextInsights;
};
